import { FC } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
} from '@chakra-ui/react';
import { ReleaseComponent } from '../../../../../../types/releaseComponent';

type Props = {
  mode: '登録' | '更新';
  values: ReleaseComponent;
  handleBack: () => void;
  handleSubmit: () => void;
};

export const ComponentRegistrationConfirmModalView: FC<Props> = ({
  mode,
  values,
  handleBack,
  handleSubmit,
}) => (
  <form onSubmit={handleSubmit}>
    <ModalContent maxHeight="90vh">
      <ModalHeader p="40px">コンポーネントの{mode}</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>コンポーネント名</FormLabel>
            <Input
              type="text"
              value={values.componentName}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormLabel>顧客環境に適用したい情報の定義</FormLabel>
          <Stack pl="5">
            <FormControl>
              <FormLabel>管理場所</FormLabel>
              <Input
                type="text"
                value={values.repositoryUrl}
                variant="flushed"
                isReadOnly
                isTruncated
              />
            </FormControl>
          </Stack>
          <FormLabel>顧客環境から収集したい情報の定義</FormLabel>
          <Stack pl="5">
            <FormControl>
              <FormLabel>マニフェストファイル名</FormLabel>
              <Input
                type="text"
                value={values.manifestName}
                width="240px"
                variant="flushed"
                isReadOnly
                isTruncated
              />
            </FormControl>
            <FormControl>
              <FormLabel>必要なキー</FormLabel>
              {values.targetKeys?.map((targetKey, index) => (
                <Stack key={index.toString()}>
                  <Input
                    type="text"
                    value={targetKey.value}
                    variant="flushed"
                    isReadOnly
                  />
                </Stack>
              ))}
            </FormControl>
          </Stack>
        </Stack>
        <Text align="center" fontWeight="bold" mt="60px">
          上記の内容でコンポーネントを{mode}しますか？
        </Text>
      </ModalBody>
      <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
        <Button
          w="140px"
          variant="outline"
          colorScheme="blackAlpha"
          onClick={handleBack}
        >
          入力画面に戻る
        </Button>
        <Button w="140px" colorScheme="blackAlpha" type="submit">
          {mode}
        </Button>
      </ModalFooter>
    </ModalContent>
  </form>
);
